import { Box, Button, Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardHeader from '../../../components/common/DashboardHeader';
import Loading from '../../../components/common/Loading';
import TraineeSidenav from '../../../components/trainee/courses/Sidenav';
import { IGetAnnouncement } from '../../../models/trainee-course.model';
import trainercoursesService from '../../../services/trainer/trainercourses.service';

export const EachAnnouncement = () => {
    const params = useParams();
    const navigate = useNavigate();
    const course_id:any = params.course_id;
    const announcement_id:any = params.id;
    const [announcement, setAnnouncement] = useState<IGetAnnouncement | any>([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (announcement_id)
            trainercoursesService.getSingleAnnouncement(announcement_id).then(
                (res) => {
                    
                    setAnnouncement(res.data)
                    setLoading(false);
                }
            )
    }, [announcement_id])
    return (
        <>
            <DashboardHeader />
            {
                loading ? <Loading /> :
                    <Box bg='#F9F8F8' height='100%'>
                        <Flex width='90%' mx='auto' pt='80px'>
                            <TraineeSidenav />
                            <Box width='80%' mx='auto' pb='200px' pl='75px' pt='50px' bg='white' pr='70px'>
                                <Text color='#1E1E1E' fontSize='28px' pb='30px' fontWeight='600'>Announcement</Text>
                                <Flex justifyContent='flex-start' alignContent='center' mb='30px'>
                                    <Button py='13px' px='30px' width="auto" mt='30px' type="submit" variant={'outline'} fontSize={11} onClick={() => navigate(`/trainee/course/${course_id}/announcement`)} colorScheme='red' size='sm'>
                                        BACK TO ANNOUNCEMENT
                                    </Button>
                                </Flex>
                                <Box>
                                    <Flex pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                        <Box mr='45px' width='90%' >
                                            <Text fontWeight='600' color='#616161' fontSize='20px'>{announcement.title}</Text>
                                            <Flex fontWeight='400' color=' #B9B9B9' mb='10px' fontSize='12px'>posted by <Text color="red" px='3px'> {announcement.user.name} </Text> ||  {moment(announcement.created_at).fromNow()}</Flex>
                                            <Text mb='10px' fontSize='16px' fontWeight='500' color=' #B9B9B9' >
                                                {announcement.description}
                                            </Text>
                                        </Box>
                                    </Flex>
                                </Box>
                            </Box>
                        </Flex>
                    </Box>
            }
        </>
    )
}

export default EachAnnouncement